import { useContext } from 'react';
import { IStoreState } from 'src/@app/props';
import { GlobalStateContext } from 'src/@app/providers/GlobalStateProvider';
import { useSelectors } from 'src/utils/storeHelpers';
import { IAuthSelectors, IAuthState } from 'src/@auth/props';
import { authActionTypes } from 'src/@auth/actionTypes';

export const useAuthSelectors: () => IAuthSelectors = () => {
  const state: IStoreState = useContext(GlobalStateContext);
  const authState: IAuthState = state.auth;

  const selectors = useSelectors(authState, (state: IAuthState) => ({
    getAccessToken: () => state.accessToken,
    shouldLogout: () => state.shouldLogout,
  }));

  return selectors;
};

export const authInitialState: IAuthState = {
  authStatus: 'Unauthenticated',
  accessToken: '',
  shouldLogout: false,
};

export const authReducer = (state: IAuthState, action: any) => {
  switch (action.type) {
    case authActionTypes.SET_ACCOUNT_INFO:
      const { authStatus, accountInfo } = action.payload;
      const accessToken = accountInfo ? accountInfo.jwtAccessToken : '';
      return Object.assign({}, state, {
        authStatus,
        accessToken,
      });
    case authActionTypes.LOG_OUT:
      return Object.assign({}, state, {
        authStatus: 'Unauthenticated',
        accessToken: '',
        shouldLogout: true,
      });
    case authActionTypes.LOGGED_OUT:
      return Object.assign({}, state, {
        shouldLogout: false,
      });
    default:
      return state;
  }
};
